import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatAbandonedEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_ABANDONED),
    version: Literal(1),
  })
);

const AiChatAbandonedEventServerRuntype = AiChatAbandonedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiChatAbandonedBrowserEvent = Static<typeof AiChatAbandonedEventBrowserRuntype>;
type AiChatAbandonedServerEvent = Static<typeof AiChatAbandonedEventServerRuntype>;

const isAiChatAbandonedBrowserEvent = (obj: BaseEvent): obj is AiChatAbandonedBrowserEvent => {
  return obj.event === 'AI Assist Abandoned';
};

const isAiChatAbandonedServerEvent = (obj: BaseEvent): obj is AiChatAbandonedServerEvent => {
  return obj.event === 'AI Assist Abandoned';
};

export {
  isAiChatAbandonedBrowserEvent,
  isAiChatAbandonedServerEvent,
  AiChatAbandonedEventBrowserRuntype,
  AiChatAbandonedEventServerRuntype,
  type AiChatAbandonedBrowserEvent,
  type AiChatAbandonedServerEvent,
};
